/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Funnel_Device_AndroidInputs */

const en_funnel_device_android = /** @type {(inputs: Funnel_Device_AndroidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Android`)
};

const es_funnel_device_android = /** @type {(inputs: Funnel_Device_AndroidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Android`)
};

/**
* | output |
* | --- |
* | "Android" |
*
* @param {Funnel_Device_AndroidInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const funnel_device_android = /** @type {((inputs?: Funnel_Device_AndroidInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Funnel_Device_AndroidInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_funnel_device_android(inputs)
	return en_funnel_device_android(inputs)
});